import { Button } from 'antd';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import React, { useEffect } from 'react';
import event from '~helpers/mixpanel';
import hexToRGBA from '~helpers/hex-to-rgba';
import SvgFormat from 'common/helpers/svgFormat';
import PropTypes from 'prop-types';
import { pageType } from '~constants/pages';

const useStyles = makeStyles(
  theme => ({
    wrap: {
      ...theme.flex.colCross,
      padding: '136px 0',
      position: 'relative',

      '& h2': {
        ...theme.typography.h2,
        color: hexToRGBA(theme.colors.gray10, 0.85),
        marginTop: 30,
      },
    },
    span: {
      ...theme.typography.body1,
      display: 'block',
      width: 604,
      marginTop: 8,
      marginBottom: 24,
      textAlign: 'center',
      color: hexToRGBA(theme.colors.gray10, 0.45),
    },
    svg: {
      width: 70,
      height: 70,
    },
  }),
  { name: 'Successful' },
);

const ProcessSuccessful = ({ refetchQueryLandlordCompanyInfo }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  useEffect(() => {
    event('Viewed OP Finishing Page', { 'Current Page Type': pageType.onBoardingPage });
  }, []);

  const handleOpenRedirectPage = () => {
    event('Clicked OP Finishing Page', {
      'Clicked Position': 'CTA Btn',
      'Current Page Type': pageType.onBoardingPage,
    });
    refetchQueryLandlordCompanyInfo();
    history.replace('/board');
  };

  return (
    <div className={classes.wrap}>
      <SvgFormat type="check-circle-success" className={classes.svg} />
      <h2>{t('successfully_create_property')}</h2>
      <span className={classes.span}>
        {t(
          'thanks_for_choosing_to_list_with_Student_your_property_listing_is_currently_being_reviewed_and_will_be_live_shortly',
        )}
      </span>
      <Button type="primary" size="large" onClick={handleOpenRedirectPage}>
        {t('go_console')}
      </Button>
    </div>
  );
};
ProcessSuccessful.propTypes = {
  refetchQueryLandlordCompanyInfo: PropTypes.func.isRequired,
};
export default ProcessSuccessful;
